import { useState, useEffect } from "react"

export const filterWebinars = (webinars, topic) => {
  const now = new Date()
  let counter = 0

  return webinars?.edges?.reduce((results, { node }) => {
    if (
      node.topic !== topic ||
      new Date(node.start_time) < now ||
      counter >= 4
    ) {
      return results
    }

    results.push(node)

    counter += 1

    return results
  }, [])
}

export default function useWebinars(topic, allWebinars = { edges: [] }) {
  const [webinars, setWebinars] = useState(filterWebinars(allWebinars, topic))

  useEffect(() => {
    setWebinars(filterWebinars(allWebinars, topic))
  }, [allWebinars, topic])

  return webinars
}
